import React, { Component, PropTypes } from 'react';
import StartFromLastSlideModal from './startFromLastSlideModal';
import './startLevel.scss';

export default class StartLevel extends Component {

  static contextTypes = {
    session: PropTypes.object.isRequired,
    program: PropTypes.object.isRequired,
    nextLevel: PropTypes.string.isRequired,
    setCurrentLevel: PropTypes.func.isRequired,
    setLastSlide: PropTypes.func.isRequired,
    setActiveSession: PropTypes.func.isRequired,
    i18n: PropTypes.func.isRequired
  }

  constructor(props) {
    super(props);
    this.state = {
      showStartFromLastSlideModal: false
    };
  }

  displayStartFromLastSlideModal() {
    this.setState({ showStartFromLastSlideModal: true });
  }

  hideStartFromLastSlideModal() {
    this.setState({ showStartFromLastSlideModal: false });
  }

  startLevel (evt) {
    const { session, setCurrentLevel, nextLevel } = this.context;
    const { lastSlide } = session;
    if (lastSlide) {
      this.displayStartFromLastSlideModal();
    } else {
      setCurrentLevel(nextLevel);
    }
    if (evt) {
      evt.preventDefault();
      evt.stopPropagation();
      evt.nativeEvent.stopPropagation();
    }
  }

  startLevelFromBeginning() {
    const { nextLevel, setCurrentLevel, setLastSlide } = this.context;
    setLastSlide()
      .then(() => setCurrentLevel(nextLevel));
  }

  startLevelFromLastSlide() {
    const { nextLevel, setCurrentLevel } = this.context;
    setCurrentLevel(nextLevel);
  }

  dashboard() {
    const { setActiveSession } = this.context;
    setActiveSession('none');
  }

  render () {
    const { nextLevel, i18n: _ } = this.context;
    const { showStartFromLastSlideModal } = this.state;
    return (
      <div className="start-level-container">
        <h1>{_('Ready!')}</h1>
        <p>{_('You are cleared for takeoff, everything is ready to go!')}</p>
        <p>&nbsp;</p>
        <div>
        <button className="btn btn-lg" onClick={::this.dashboard}>
          {_('Back to Dashboard')}
        </button>
        <button className="btn btn-lg btn-primary" onClick={::this.startLevel}>
          {(nextLevel !== 'completed')
          ? <span>{_`Start Level ${nextLevel}`}</span>
          : <span>{_('Re-Enter')}</span>
          }
        </button>
        </div>
        <StartFromLastSlideModal
            showModal={showStartFromLastSlideModal}
            closeModal={::this.hideStartFromLastSlideModal}
            startFromBeginning={::this.startLevelFromBeginning}
            startFromLastSlide={::this.startLevelFromLastSlide} />
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/views/session/presentation/components/startLevel.js